import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import store from '../store';
import { setLocale as localeAction } from '../store/application/actions';
import { PublicLocale } from '../../types';
import Utils from '../../utilities/Utils';
import moment from '../../utilities/Moment';

const DEFAULT_LOCALE = 'en'

export const initializeTranslations = (translationsBaseUrl: string, locale?: PublicLocale) => {
  // initialise() (App.tsx) re-runs this on every mount/reload. Re-running
  // i18n.init() flips the instance back to "not ready", which re-suspends
  // any translated component under the widget's Suspense boundary and
  // unmounts/remounts the whole tree — an infinite loop, since the remount
  // calls initialise() again. Only initialise once; later calls just need
  // setLocale().
  if (i18n.isInitialized) return

  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      fallbackLng: DEFAULT_LOCALE,
      lng: DEFAULT_LOCALE,
      keySeparator: '::',
      nsSeparator: false,
      interpolation: {
        escapeValue: true,
      },
      backend: {
        loadPath: `${translationsBaseUrl}app/locales/{{lng}}.json`,
        // These files aren't served with a content hash/uuid in their path,
        // so bust the cache on every fresh init to avoid a stale copy.
        queryStringParams: { v: Utils.uuid() },
      },
    });

}

export const setLocale = (locale: string) => {
  i18n.changeLanguage(locale)
  store.dispatch(localeAction(locale as PublicLocale))
  moment.locale(locale)
}

export default i18n;